var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upload-video-component",
      class: {
        "block-file-selection": !_vm.isAllowToSelectFile,
        dragover: _vm.dragover
      },
      on: {
        click: _vm.onClick,
        drop: function($event) {
          $event.preventDefault()
          return _vm.onDrop($event)
        },
        dragover: function($event) {
          $event.preventDefault()
          _vm.dragover = true
        },
        dragleave: function($event) {
          $event.preventDefault()
          _vm.dragover = false
        }
      }
    },
    [
      _c("input", {
        ref: "fileInput",
        attrs: { type: "file", accept: ".mp4, .webm, .mov, .avi, .mkv, .flv" },
        on: {
          change: function($event) {
            return _vm.selectionProcessing($event)
          }
        }
      }),
      _vm._v(" "),
      Object.keys(_vm.processingErrors).length > 0 ||
      _vm.status === "INITIATED" ||
      _vm.isReserved
        ? _c(
            "div",
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.processingErrors, function(messages, field) {
                return Object.keys(_vm.processingErrors).length > 0
                  ? _c("div", { staticClass: "errors" }, [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm._f("unSnakeCase")(_vm._f("capitalize")(field))
                          )
                        )
                      ]),
                      _vm._v(" "),
                      field === "space_limited"
                        ? _c("div", { staticClass: "space_limited_msg" }, [
                            _vm._v(
                              "\n                The file you are trying to upload exceeds the allotted storage.\n                Please clean your "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "/my_storage",
                                  target: "_blank"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                  }
                                }
                              },
                              [_vm._v("Storage")]
                            ),
                            _vm._v(
                              " first before attempting to re-upload\n                it"
                            ),
                            !_vm.is_plus_user
                              ? _c("span", [
                                  _vm._v(", or upgrade to "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "/subscriptions",
                                        target: "_blank"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [_vm._v("Plus account")]
                                  ),
                                  _vm._v(".")
                                ])
                              : _vm._e()
                          ])
                        : _c(
                            "ul",
                            _vm._l(messages, function(message) {
                              return _c("li", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm._f("capitalize")(message)) +
                                    "\n                "
                                )
                              ])
                            }),
                            0
                          )
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        : _vm.warning_message
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v(_vm._s(_vm.warning_message))
          ])
        : _vm.status === "PARSING"
        ? _c("div", [_vm._v("Checking...")])
        : _vm.status === "UPLOADING"
        ? _c("div", [
            _vm._v("Uploading: " + _vm._s(_vm.uploadPercentage) + "%")
          ])
        : _vm.inQueue
        ? _c("div", [_vm._v("In queue...")])
        : _vm.isProgressing
        ? _c("div", [
            _vm._v("Processing: " + _vm._s(_vm.job_percent_complete) + "%")
          ])
        : ["ERROR"].includes(_vm.status)
        ? _c("div", [_vm._v("Processing error: " + _vm._s(_vm.id))])
        : ["CANCELED"].includes(_vm.status)
        ? _c("div", [_vm._v("Processing is cancelled: " + _vm._s(_vm.id))])
        : ["COMPLETE"].includes(_vm.status)
        ? _c("div", [_vm._v("Complete")])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-video-title" }, [
      _vm._v("\n            Drop file here or click to "),
      _c("b", [_vm._v("upload")]),
      _vm._v(".\n        ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }